import { Link } from '../routing/Router'

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link className="brand" to="/" aria-label="Комонтроль — главная">
      <svg className="brand-mark" viewBox="0 0 64 64" aria-hidden="true">
        <path d="M32 4 54 16v32L32 60 10 48V16Z" />
        <path d="M32 13 46 21v22L32 51 18 43V21Z" />
      </svg>
      {!compact && <span>Комонтроль</span>}
    </Link>
  )
}
